import { render, staticRenderFns } from "./coachMechanismDetails.vue?vue&type=template&id=032a0508&scoped=true&"
import script from "./coachMechanismDetails.vue?vue&type=script&lang=js&"
export * from "./coachMechanismDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a0508",
  null
  
)

export default component.exports